/* The subscription pair discount, applied as a discount code by the theme (8 Oct 2026).

   Why a code: the two packs on subscription together are 20% off in total, and that must
   hold on every renewal. App discounts (SMART Discounts) are Shopify Functions, which only
   run at checkout, so renewals lost the bundle part. A Shopify code discount set to "all
   recurring payments" is saved on the subscription contract and survives renewals. But a
   Shopify discount cannot say "one Day and one Night": its only condition is a minimum
   amount or quantity, which two of the same pack would also meet. So the theme decides
   when the pair is really there and applies or removes the code itself; the code is not
   published anywhere, so nobody types it in for two of the same pack.

   The pair: at least one line of pack A and one line of pack B, both on a selling plan.
   Pack ids and the code come from theme settings (window.KODO_PAIR_CODE, written by
   snippets/header-actions.liquid). An empty code switches this off.

   Runs on load and after every cart:update. Other codes in the cart are kept. */
(function () {
  if (window.__kodoPairCode) return;
  window.__kodoPairCode = true;

  var cfg = window.KODO_PAIR_CODE || {};
  var code = (cfg.code || '').trim();
  var packA = Number(cfg.packA), packB = Number(cfg.packB);
  if (!code || !packA || !packB) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false, again = false;

  function pairPresent(cart) {
    var a = false, b = false;
    (cart.items || []).forEach(function (line) {
      if (!line.selling_plan_allocation) return;
      if (line.product_id === packA) a = true;
      if (line.product_id === packB) b = true;
    });
    return a && b;
  }

  function hasCode(cart) {
    return (cart.discount_codes || []).some(function (d) { return String(d.code).toUpperCase() === code.toUpperCase(); });
  }

  function otherCodes(cart) {
    return (cart.discount_codes || []).map(function (d) { return d.code; }).filter(function (c) { return String(c).toUpperCase() !== code.toUpperCase(); });
  }

  function sync() {
    if (busy) { again = true; return; }
    busy = true;
    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var want = pairPresent(cart), have = hasCode(cart);
        if (want === have) return null;
        var codes = otherCodes(cart);
        if (want) codes.push(code);
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: codes.join(',') }),
        }).then(function (r) { return r.ok ? r.json() : null; }).then(function (updated) {
          if (!updated) return;
          /* the drawer and the header count re-render from this; source 'kodo-pair-code' keeps
             the add-to-cart handlers from treating it as a new add */
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: updated, sourceId: 'kodo-pair-code', data: { source: 'kodo-pair-code', itemCount: updated.item_count } },
          }));
        });
      })
      .catch(function () {})
      .then(function () { busy = false; if (again) { again = false; sync(); } });
  }

  document.addEventListener('cart:update', function (e) {
    var d = e.detail && e.detail.data;
    if (d && d.source === 'kodo-pair-code') return; // our own refresh
    sync();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
})();
